const { format, addMinutes } = require("date-fns");

const configurationForToken = (token) => {
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

const userTypes = {
  admin: { type: "admin", bubbleText: "Administrador" },
  manager: { type: "manager", bubbleText: "Encargado" },
  driver: { type: "driver", bubbleText: "Conductor" },
};

const requirementStates = {
  pending: "Pendiente",
  "in progress": "En progreso",
  done: "Hecho",
};

const requirementTypes = {
  service: "Service",
  maintenance: "Mantenimiento",
  flaw: "Desperfecto",
  accident: "Accidente",
  sinister: "Siniestro",
  other: "Otro",
};

const deregisterVehicleTypes = {
  sale: "Venta",
  "total destruction": "Destrucción Total",
  other: "Otro",
};

const alertTypes = {
  reminder: 'Recordatorio',
  document: 'Documento',
  maintenance: {
    wheel: 'Rueda',
    chain: 'Correa',
    service: 'Servicio'
  }
}

const resolveTimezoneOffsetError = (date, formatOfReturn = null) => {
  const correctDate = addMinutes(new Date(date), new Date().getTimezoneOffset())
  return formatOfReturn ? format(correctDate, formatOfReturn) : correctDate
}

module.exports = { configurationForToken, resolveTimezoneOffsetError, userTypes, requirementStates, requirementTypes, deregisterVehicleTypes, alertTypes };



// WEBPACK FOOTER //
// ./src/CommonConstants.js